const paths = {
  home: '<path d="m3 10 9-7 9 7v10H3Z"/><path d="M9 20v-7h6v7"/>',
  book: '<path d="M3 4h5a4 4 0 0 1 4 3 4 4 0 0 1 4-3h5v15h-5a4 4 0 0 0-4 2 4 4 0 0 0-4-2H3Z"/><path d="M12 7v14"/>',
  audio: '<path d="M4 14v-3a8 8 0 0 1 16 0v3"/><rect x="3" y="12" width="4" height="8" rx="2"/><rect x="17" y="12" width="4" height="8" rx="2"/>',
  stories: '<path d="M4 3h12a3 3 0 0 1 3 3v15H7a3 3 0 0 1-3-3Zm0 14h15M8 7h7M8 11h5"/>',
  stats: '<path d="M4 20V10M12 20V4M20 20v-7"/>',
  play: '<path d="m8 4 12 8-12 8Z"/>',
  pause: '<path d="M8 4v16M16 4v16"/>',
  next: '<path d="m8 5 7 7-7 7"/>',
  back: '<path d="m14 5-7 7 7 7"/>',
  repeat: '<path d="M3 8a9 9 0 0 1 15-4l3 3M21 2v5h-5M21 16a9 9 0 0 1-15 4l-3-3M3 22v-5h5"/>',
  globe: '<circle cx="12" cy="12" r="9"/><ellipse cx="12" cy="12" rx="4" ry="9"/><path d="M3 12h18"/>',
  check: '<path d="m5 12 4 4L19 6"/>',
  close: '<path d="m6 6 12 12M6 18 18 6"/>',
  sound: '<path d="m11 4-5 4H3v8h3l5 4ZM15 8a6 6 0 0 1 0 8M18 5a10 10 0 0 1 0 14"/>',
  bolt: '<path d="m14 2-9 12h7l-2 8 9-12h-7Z"/>',
  arrow: '<path d="M4 12h16m-6-6 6 6-6 6"/>',
  rewind: '<path d="m11 5-8 7 8 7Zm10 0-8 7 8 7Z"/>',
  forward: '<path d="m3 5 8 7-8 7Zm10 0 8 7-8 7Z"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
} as const;

export type IconName = keyof typeof paths;

/** Decorative stroke icon (styled by the `svg` rules in styles.css). Path data is static and trusted. */
export function Icon({ name }: { name: IconName }) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" dangerouslySetInnerHTML={{ __html: paths[name] ?? paths.play }} />;
}
